import dayjs from "dayjs";
import { calendarSliceActions, useCalendarEvents } from "@/features/calendar/model";
import { useAppDispatch, useAppSelector } from "@/services/store";
import { isVoid } from "@/shared/utils";
import {
  CalendarAnniversaryListMobile,
  CalendarBirtdayListMobile,
  CalendarEventListMobile,
} from "@/entities/calendar-event";
import { AppDrawer } from "@/shared/Components/AppDrawer";
import styles from "./styles.module.scss";

export const EventList = () => {
  const dispatch = useAppDispatch();

  const { selectedDate, drawerIsOpen } = useAppSelector((state) => state.calendarSlice);
  const { hasEvents, currentDateEvents } = useCalendarEvents(dayjs(selectedDate));

  const date = dayjs(selectedDate);

  return (
    <div className={styles["drawer-wrapper"]}>
      <AppDrawer
        placement="bottom"
        open={hasEvents && drawerIsOpen}
        closable={false}
        height="80%"
        onClose={() => {
          dispatch(calendarSliceActions.closeDrawer());
        }}
        rootClassName={styles.drawer}
        destroyOnClose
      >
        {!isVoid(currentDateEvents.importantNotes) && (
          <CalendarEventListMobile date={date} events={currentDateEvents.importantNotes} />
        )}
        {!isVoid(currentDateEvents.birthdays) && (
          <CalendarBirtdayListMobile date={date} events={currentDateEvents.birthdays} />
        )}
        {!isVoid(currentDateEvents.anniversaries) && (
          <CalendarAnniversaryListMobile date={date} events={currentDateEvents.anniversaries} />
        )}
        {!isVoid(currentDateEvents.notes) && (
          <CalendarEventListMobile date={date} events={currentDateEvents.notes} />
        )}
      </AppDrawer>
    </div>
  );
};
